import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import DallasTextSkeleton from '~/app/_ui/Dallas/Text/DallasTextSkeleton';
import DallasSkeleton from '~/app/_ui/Dallas/Skeleton/DallasSkeleton';
import DallasStack from '~/app/_ui/Dallas/Stack/DallasStack';

import styles from './StopsSkeletonCell.module.scss';

type Props = {
  className?: string;
};

export default function StopsSkeletonCell({ className }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasStack gap="xs" direction="row" alignVertical="center">
        <DallasSkeleton className={styles.pickupIndicator} variant="circular" />
        <DallasTextSkeleton variant="captionL" fullLine />
      </DallasStack>
      <DallasStack gap="xs" direction="row" alignVertical="center">
        <DallasSkeleton className={styles.deliveryIndicator} />
        <DallasTextSkeleton variant="captionL" fullLine />
      </DallasStack>
    </DallasTableDataCell>
  );
}
